(function () {
  var APPOINTO_TRIGGER = '#appointo-btn';
  var APPOINTO_MODAL = '#appointo-modal';
  var PRODUCT_BUTTON =
    '.product__info product-form form[action*="/cart/add"] button[type="submit"][name="add"], ' +
    '.quick-view product-form form[action*="/cart/add"] button[type="submit"][name="add"], ' +
    '.product-form__sticky-buy-button button[type="submit"][name="add"]';
  var BRIDGED_ATTRIBUTE = 'data-mystic-appointo-trigger';
  var READY_CLASS = 'mystic-appointo-bridge-ready';
  var OPEN_CLASS = 'mystic-appointo-user-open';
  var LABEL = 'Schedule Your Time';
  var decorationQueued = false;
  var mobileCalendarRefreshQueued = false;

  function getAppointoTrigger() {
    return document.querySelector(APPOINTO_TRIGGER);
  }

  function decorateProductButtons() {
    if (!getAppointoTrigger()) return;

    document.querySelectorAll(PRODUCT_BUTTON).forEach(function (button) {
      var label = button.querySelector('[data-button-text]');
      if (label && label.textContent.trim() !== LABEL) label.textContent = LABEL;

      if (button.getAttribute('aria-label') !== LABEL) button.setAttribute('aria-label', LABEL);
      if (button.getAttribute(BRIDGED_ATTRIBUTE) !== 'true') {
        button.setAttribute(BRIDGED_ATTRIBUTE, 'true');
      }
    });

    if (!document.body.classList.contains(OPEN_CLASS)) {
      document.body.classList.add(READY_CLASS);
      document.body.classList.remove('appointo-fixed');
    }
  }

  function queueDecoration() {
    if (decorationQueued) return;
    decorationQueued = true;
    window.requestAnimationFrame(function () {
      decorationQueued = false;
      decorateProductButtons();
    });
  }

  function refreshEmptyMobileCalendar() {
    if (window.innerWidth > 749 || mobileCalendarRefreshQueued) return;

    mobileCalendarRefreshQueued = true;
    [80, 360, 900].forEach(function (delay, index) {
      window.setTimeout(function () {
        var modal = document.querySelector(APPOINTO_MODAL);
        var calendar = modal && modal.querySelector('.vanilla-calendar');
        var calendarBody = calendar && calendar.querySelector('.vanilla-calendar-body');
        var hasDates = calendarBody && calendarBody.querySelector('.vanilla-calendar-date');

        if (!modal || window.getComputedStyle(modal).display === 'none') {
          if (index === 2) mobileCalendarRefreshQueued = false;
          return;
        }

        if (calendarBody && !hasDates) {
          var variantSelect = modal.querySelector('#appointo-variant-select');
          calendarBody.setAttribute('data-mystic-refresh', String(delay));
          window.dispatchEvent(new Event('resize'));
          if (variantSelect && variantSelect.value) {
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (index === 2) mobileCalendarRefreshQueued = false;
      }, delay);
    });
  }

  function activateAppointo(event) {
    var target = event.target;
    var button = target && target.closest
      ? target.closest('[' + BRIDGED_ATTRIBUTE + '="true"]')
      : null;
    if (!button) return;

    var appointoTrigger = getAppointoTrigger();
    if (!appointoTrigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var modal = document.querySelector(APPOINTO_MODAL);
    if (
      document.body.classList.contains(OPEN_CLASS) &&
      modal &&
      window.getComputedStyle(modal).display !== 'none'
    ) {
      return;
    }

    document.body.classList.add(OPEN_CLASS);
    document.body.classList.add('appointo-fixed');
    document.body.classList.remove(READY_CLASS);
    appointoTrigger.click();
    refreshEmptyMobileCalendar();
  }

  window.addEventListener('click', activateAppointo, true);

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.appointo-close')) return;
      window.setTimeout(function () {
        document.body.classList.remove(OPEN_CLASS);
        document.body.classList.remove('appointo-fixed');
        document.body.classList.add(READY_CLASS);
      }, 0);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!document.querySelector(APPOINTO_MODAL)) return;
    window.setTimeout(function () {
      document.body.classList.remove(OPEN_CLASS);
      document.body.classList.remove('appointo-fixed');
      document.body.classList.add(READY_CLASS);
    }, 0);
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldDecorate = mutations.some(function (mutation) {
      var mutationTarget =
        mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;

      if (
        mutationTarget &&
        mutationTarget.closest &&
        mutationTarget.closest(PRODUCT_BUTTON)
      ) {
        return true;
      }

      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        if (node.closest && node.closest(APPOINTO_MODAL)) return false;
        return (
          (node.matches && (node.matches(APPOINTO_TRIGGER) || node.matches(PRODUCT_BUTTON))) ||
          (node.querySelector &&
            (node.querySelector(APPOINTO_TRIGGER) || node.querySelector(PRODUCT_BUTTON)))
        );
      });
    });

    if (shouldDecorate) queueDecoration();
  });
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });

  document.addEventListener('shopify:section:load', queueDecoration);
  document.addEventListener('DOMContentLoaded', decorateProductButtons);
  window.addEventListener('load', decorateProductButtons);
})();
